'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNameFromVisitor = exports.getUrlForMessage = exports.sleepBeforeProceeding = exports.getVidOrUtkFromChannel = exports.isDebug = undefined;
exports.matchesLegacyTimestamp = matchesLegacyTimestamp;
exports.hasLegacyTimestamp = hasLegacyTimestamp;
exports.containsPrivateChannel = containsPrivateChannel;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _hubspotUrlinator = require('hubspot.urlinator.Url');

var _hubspotUrlinator2 = _interopRequireDefault(_hubspotUrlinator);

var _hubspot = require('hubspot.SafeStorage');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _underscore = require('underscore');

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _strings = require('conversations-core/constants/strings');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_MESSAGE_SEEN_PREFIX = 'messages:lastMessageSeen';

var getLastSeenForConversation = (0, _underscore.memoize)(function (conversation) {
  var channelForLastSeen = conversation.channel;

  try {
    var storedLastSeenInfo = JSON.parse(_hubspot2.default.getItem(LAST_MESSAGE_SEEN_PREFIX + ':' + conversation.portalId));
    if (storedLastSeenInfo !== null && typeof storedLastSeenInfo[channelForLastSeen] !== 'undefined') {
      return parseInt(storedLastSeenInfo[channelForLastSeen], 10);
    }
  } catch (err) {
    return null;
  }

  return conversation.lastSeenTimestamp;
});

function matchesLegacyTimestamp(message, conversation) {
  return getLastSeenForConversation(conversation) === (0, _PubNubMessageModel.getTimestamp)(message);
}

function hasLegacyTimestamp(conversation) {
  return getLastSeenForConversation(conversation) != null;
}

var envSuffix = function envSuffix() {
  return _enviro2.default.getInternal('api') === 'qa' ? 'qa' : 'prod';
};

var isDebug = exports.isDebug = function isDebug() {
  return envSuffix() === 'qa';
};

var getVidOrUtkFromChannel = exports.getVidOrUtkFromChannel = function getVidOrUtkFromChannel(channel) {
  return channel.split('-').pop();
};

var sleepBeforeProceeding = exports.sleepBeforeProceeding = function sleepBeforeProceeding() {
  var date = new Date();
  var curDate = new Date();
  while (curDate - date < 250) {
    curDate = new Date();
  }
};

var getUrlForMessage = exports.getUrlForMessage = function getUrlForMessage() {
  var url = window.location !== window.parent.location ? document.referrer : document.origin;

  var parsedUrl = new _hubspotUrlinator2.default(url);

  return parsedUrl.hostplus;
};

var getNameFromVisitor = exports.getNameFromVisitor = function getNameFromVisitor(visitor) {
  // this is copied from old messages-- might be a bit aggressive but we always get bugs with this
  // so trying to be proactive

  var label = '';

  if (visitor !== null) {
    var firstName = visitor.firstName;
    var lastName = visitor.lastName;

    var fullName = (0, _underscore.compact)([firstName, lastName]);
    if (fullName.length > 0) {
      label = fullName.join(' ').trim();
    }

    if (!label && visitor.email) {
      label += visitor.email;
    }
  }

  if (!label) {
    return _I18n2.default.text('unknownVisitor');
  }
  return label;
};

function containsPrivateChannel(channels) {
  return channels.some(function (channel) {
    return channel.indexOf(_strings.PRIVATE_CHANNEL) > -1;
  });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/utils/helpers.js
// module id = 81
// module chunks = 0 1